module.exports = __webpack_public_path__ + "static/img/payslip.2933ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/payslip.png
// module id = 1487
// module chunks = 2